import React from "react";
import classes from "./header.module.css";

const Header = ({ title }) => {
  return (
    <header className={classes.header}>
      <h1 className={classes.title}>{title}</h1>
      <p className={classes.subtitle}>Free tool made with love by Spicin</p>
    </header>
  );
};

export default Header;
